
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Grid, TextField } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query";
import { startSavingCategoria } from "../../../../services";

import Swal from "sweetalert2";





export const FormCreateUpdateCategoria = ({ initialState }) => {


    const { id } = useParams();
    const queryClient = useQueryClient();


    const [formProducto, setFormProducto] = useState( initialState );
    const { nombre } = formProducto;
    const  handleChangeInput = ({ target }) => {
        setFormProducto({ ...formProducto, [target.name]: target.value});
    }

    


    const crearActInformacion = async(e) => {
        e.preventDefault();
        const isUpdate = (id != 'new') ? id : null;
        if([nombre].includes('') ){
            return Swal.fire('Error', 'Formulario incorrecto por favor llene todos los campos', 'error');
        }


        const result = await Swal.fire({
            title: `${(isUpdate) ? 'Actualizar' : 'Crear'} Categoria`,
            text: `¿Esta seguro de ${(isUpdate) ? 'Actualizar' : 'Crear'} Categoria?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si ${(id) ? 'Actualizar' : 'Crear'}`,
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        const resp = await startSavingCategoria({ ...formProducto, id: isUpdate });
        if(resp){
            if(!isUpdate) { 
                setFormProducto(initialState); 
            }else {
                queryClient.invalidateQueries({queryKey: ['categoria-id', id]});
            }
            queryClient.invalidateQueries({queryKey: ['categorias-list']});
        }
    }





    return (

        <form onSubmit={ crearActInformacion } >
            <Grid container spacing={ 2 }>
                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Nombre'
                        type='text'
                        placeholder='Nombre'
                        fullWidth
                        name='nombre'
                        value={ nombre }
                        onChange={ handleChangeInput }
                    />
                </Grid>
            </Grid>

            <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                <Grid item xs={ 12 } sm={ 8 } >
                    <Button variant='contained' fullWidth type='submit'>
                        {`${(id != 'new') ? 'Actualizar' : 'Crear'} Categoria`}
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}
